<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          Review Questions
        </v-card-title>
        <v-divider></v-divider>
        <v-form ref="form" v-model="valid">
          <v-card-text class="subtitle-1">
            <v-row>
              <v-col cols="12" md="6" v-if="annual_review_sections.length">
                <v-btn
                  color="secondary"
                  text
                  class="light-background"
                  x-large
                  block
                  @click="showEditQuestion"
                >
                  <v-icon class="mr-2">add_circle</v-icon>
                  Add a new question
                </v-btn>
              </v-col>
              <v-col cols="12" md="6">
                <v-btn
                  color="secondary"
                  text
                  class="light-background"
                  x-large
                  block
                  @click="showEditSection"
                >
                  <v-icon class="mr-2">playlist_add</v-icon>
                  Add a new section
                </v-btn>
              </v-col>
            </v-row>
            <v-expansion-panels class="py-4">
              <annual-review-section-item
                v-for="(item, i) in sorted_annual_review_sections"
                :key="i"
                :section="item"
                :allowUp="i > 0"
                :allowDown="i < sorted_annual_review_sections.length - 1"
                v-on:edit="showEditSection(item)"
                v-on:edit-question="showEditQuestion"
                v-on:moveup="moveSectionUp(i)"
                v-on:movedown="moveSectionDown(i)"
              ></annual-review-section-item>
            </v-expansion-panels>
            <v-row>
              <v-col cols="12">
                <info-card icon="event" title="Annual Review Question Summary">
                  The members in your company will be asked to answer
                  {{
                    _.reduce(
                      annual_review_sections,
                      function(sum, section) {
                        return sum + section.questions.length;
                      },
                      0
                    )
                  }}
                  questions in {{ annual_review_sections.length }} unique
                  sections.
                </info-card>
              </v-col>
            </v-row>
            <edit-annual-review-section-dialog
              ref="editSection"
            ></edit-annual-review-section-dialog>
            <edit-annual-review-question-dialog
              ref="editQuestion"
            ></edit-annual-review-question-dialog>
          </v-card-text>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import EditAnnualReviewQuestionDialog from "@/components/annualreviews/EditAnnualReviewQuestionDialog";
import EditAnnualReviewSectionDialog from "@/components/annualreviews/EditAnnualReviewSectionDialog";
import AnnualReviewSectionItem from "@/components/annualreviews/AnnualReviewSectionItem";
export default {
  components: {
    EditAnnualReviewSectionDialog,
    EditAnnualReviewQuestionDialog,
    AnnualReviewSectionItem
  },
  name: "AnnualReviewSettingsQuestions",
  data: () => ({
    saving: false,
    loading: false,
    valid: false
  }),
  computed: {
    sorted_annual_review_sections() {
      return this._.orderBy(
        this.annual_review_sections,
        ["sortOrder"],
        ["asc"]
      );
    },
    ...mapGetters({
      annual_review_sections: "settings/annual_review_sections"
    })
  },
  created() {
    this.loadSections();
  },
  methods: {
    showEditQuestion(question) {
      this.$refs.editQuestion.showDialog(question);
    },
    showEditSection(section) {
      this.$refs.editSection.showDialog(section);
    },
    moveSectionUp(index) {
      if (index >= 0) {
        let current = this.sorted_annual_review_sections[index];
        let previous = this.sorted_annual_review_sections[index - 1];

        current.sortOrder = index;
        previous.sortOrder = index + 1;

        Promise.all([
          this.$store.dispatch("settings/saveAnnualReviewSection", current),
          this.$store.dispatch("settings/saveAnnualReviewSection", previous)
        ])
          .then(() => {
            this.$root.$snackbarSuccess("Order updated");
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while updating section order."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    moveSectionDown(index) {
      if (index >= 0) {
        let current = this.sorted_annual_review_sections[index];
        let next = this.sorted_annual_review_sections[index + 1];

        current.sortOrder = index + 2;
        next.sortOrder = index + 1;

        Promise.all([
          this.$store.dispatch("settings/saveAnnualReviewSection", current),
          this.$store.dispatch("settings/saveAnnualReviewSection", next)
        ])
          .then(() => {
            this.$root.$snackbarSuccess("Order updated");
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while updating section order."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    loadSections() {
      this.loading = true;
      this.$store
        .dispatch("settings/getAnnualReviewSections")
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading your review settings."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
